import { render } from "./OnboardingEmailFinal.vue?vue&type=template&id=f1f92f28&scoped=true"
import script from "./OnboardingEmailFinal.vue?vue&type=script&lang=js"
export * from "./OnboardingEmailFinal.vue?vue&type=script&lang=js"

import "./OnboardingEmailFinal.vue?vue&type=style&index=0&id=f1f92f28&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f92f28"]])

export default __exports__